import { UpdateUserInput, _Boolean } from '@/API';
import { checkStepFunctionStatus } from '@/appsync/lambda/checkStepFunctionStatusService';
import { updateUser } from '@/appsync/service/UserMutationService';
import { i18n } from '@/plugins/i18n/i18n';
import { globalSnackbarModule } from '@/store/modules/GlobalSnackbarStore';
import { boolean2_BooleanEnum } from '@/utils/CommonUtils';
import { StepFunctionStatus } from '@/utils/consts';

export enum UserRoleTypes {
  Admin,
  General,
}

export const userRoleTypes2_booleanEnum = (userRole: UserRoleTypes): _Boolean =>
  boolean2_BooleanEnum(userRole === UserRoleTypes.Admin);

export const _booleanEnum2userRoleTypes = (isAdmin: _Boolean): UserRoleTypes =>
  isAdmin === _Boolean._true ? UserRoleTypes.Admin : UserRoleTypes.General;

export const updateUserRole = async (
  loginName: string,
  tenant: string,
  landscape: string,
  userRole: UserRoleTypes
) => {
  const updateUserInput: UpdateUserInput = {
    loginName,
    tenant,
    landscape,
    isAdmin: userRoleTypes2_booleanEnum(userRole),
  };

  await updateUser(updateUserInput);
};

export const callCheckStepFunctionStatus = async (
  executionArn: string,
  attempt: number = 0
) => {
  const maxAttempts = 5;
  const backoffInterval = 4000;

  try {
    const status: StepFunctionStatus = await checkStepFunctionStatus(
      executionArn
    );

    if (status === StepFunctionStatus.SUCCEEDED) {
      globalSnackbarModule.showSnackbarAction(
        i18n.tc('commonSetting.userManagement.deletionProcessComplete')
      );
      globalSnackbarModule.hideProgressCircularAction();
      return;
    }

    if (
      [
        StepFunctionStatus.FAILED,
        StepFunctionStatus.TIMED_OUT,
        StepFunctionStatus.ABORTED,
      ].includes(status)
    ) {
      globalSnackbarModule.showSnackbarAction(
        i18n.tc('commonSetting.userManagement.deletionProcessFailed')
      );
      globalSnackbarModule.hideProgressCircularAction();
      return;
    }

    if (attempt < maxAttempts) {
      const backoffTime = backoffInterval * Math.pow(2, attempt);
      await new Promise(resolve => setTimeout(resolve, backoffTime));
      await callCheckStepFunctionStatus(executionArn, attempt + 1);
    } else {
      globalSnackbarModule.showSnackbarAction(
        i18n.tc('commonSetting.userManagement.deletionProcessFailed')
      );
      globalSnackbarModule.hideProgressCircularAction();
    }
  } catch (error) {
    globalSnackbarModule.showSnackbarAction(
      i18n.tc('commonSetting.userManagement.deletionProcessFailed')
    );
    globalSnackbarModule.hideProgressCircularAction();
  }
};
